import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IMessageListItem {
    id: string;
    companyId: string;
    companyName: string;
    date: number;
    title: string;
    content: string;
    modifyUser: IModifyUser;
    modifyUserCompanyName: string;
    typeName: string;
    typeImage: string;
    locked: boolean;
    isRead: boolean;
    requiresReceipt: boolean;
    requiresReceiptIsRead: boolean;
    expired: boolean;
    notVisibleYet: boolean;
    attachments: IFileAttachment[];
}

export class MessageListItem implements IMessageListItem {
    id: string;
    companyId: string;
    companyName: string;
    date: number;
    title: string;
    content: string;
    modifyUser: ModifyUser;
    modifyUserCompanyName: string;
    typeName: string;
    typeImage: string;
    locked: boolean;
    isRead: boolean;
    requiresReceipt: boolean;
    requiresReceiptIsRead: boolean;
    expired: boolean;
    notVisibleYet: boolean;
    attachments: FileAttachment[];

    constructor();
    constructor(obj: IMessageListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.companyName = obj && obj.companyName || "";
        this.date = obj && obj.date || null;
        this.title = obj && obj.title || "";
        this.content = obj && obj.content || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.modifyUserCompanyName = obj && obj.modifyUserCompanyName || "";
        this.typeName = obj && obj.typeName || "";
        this.typeImage = obj && obj.typeImage || "";
        this.locked = obj && obj.locked || false;
        this.isRead = obj && obj.isRead || false;
        this.requiresReceipt = obj && obj.requiresReceipt || false;
        this.requiresReceiptIsRead = obj && obj.requiresReceiptIsRead || false;
        this.expired = obj && obj.expired || false;
        this.notVisibleYet = obj && obj.notVisibleYet || false;
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
    }
}